module.exports = __webpack_public_path__ + "img/greg.2c273b6e.jpg";